import { MDXProvider } from '@mdx-js/react'
import { graphql } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import React from 'react'

import ArticleLayout from 'components/layout/article-layout/article-layout'
import {
  Blockquote,
  SubHeading,
  ListItem,
  Paragraph,
  List,
  Category,
  Title,
} from 'components/typography'

interface Props {
  data: {
    currentBlog: {
      frontmatter: BlogFrontmatter
      body: string
      timeToRead: number
    }
  }
}

interface BlogFrontmatter {
  version: string
  date: Date
  description: string
  path: string
  title: string
}

const components = {
  blockquote: Blockquote,
  h1: Title,
  h2: SubHeading,
  h3: SubHeading,
  li: ListItem,
  p: Paragraph,
  ul: List,
}

// TODO: when we have enough blog posts, show related posts (using BlogCards component)
// Create a foreign-key relationship between the 'related' array in the frontmatter and the actual blog data
// If 'related' isn't defined, maybe default to a weighted system using categories and tags, or just the 3 most recent in a category
const LegalPage = ({ data }: Props) => {
  const { currentBlog } = data
  const { frontmatter, body } = currentBlog

  return (
    <ArticleLayout
      title={frontmatter.title}
      description={frontmatter.description}
      slug={frontmatter.path}
      navItems={[
        {
          to: '/legal/privacy/',
          label: 'Privacy Policy',
        },
        {
          to: '/legal/terms/',
          label: 'Terms of Service',
        },
      ]}
    >
      <Category>{frontmatter.version}</Category>
      <MDXProvider components={components}>
        <MDXRenderer>{body}</MDXRenderer>
      </MDXProvider>
    </ArticleLayout>
  )
}

export const pageQuery = graphql`
  query ($path: String!) {
    currentBlog: mdx(frontmatter: { path: { eq: $path } }) {
      body
      timeToRead
      frontmatter {
        date(formatString: "MMMM D, YYYY")
        description
        path
        title
      }
    }
  }
`

export default LegalPage
